import type { Term } from '@court-sync/shared';

/** Terms that have not ended before today (local calendar). Sorted by start date ascending. */
export function filterCurrentOrFutureTerms(terms: Term[]): Term[] {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  return terms
    .filter((t) => {
      const end = t.endDate instanceof Date ? t.endDate : new Date(t.endDate);
      return end.getTime() >= startOfToday.getTime();
    })
    .sort((a, b) => {
      const sa = a.startDate instanceof Date ? a.startDate : new Date(a.startDate);
      const sb = b.startDate instanceof Date ? b.startDate : new Date(b.startDate);
      return sa.getTime() - sb.getTime();
    });
}
